import React from 'react'
import "../Styles/SecondCard.scss"
import emoji from "../assets/Vector.svg"
const SecondCard = ({result}) => {
  return (
    <div className="secondWrapper">
      <div className="text">Speed</div>
      <div className="text2 ">
        50 <span className="">mins</span>
      </div>
      <div className="text3">Topper speed - {result?.timing?.highest} mins</div>
      <div className="imgdiv">
        <div className="text4">Worst time - {result?.timing?.lowest } mins</div>
        <div className="div1">
          <img
            loading="lazy"
            src={emoji}
            style={{width:"2.25rem","shrink":"0"}}
          />
          <div>
            <span  style={{fontWeight:"600"}}>Great Job!</span> you are
            only {result?.timing?.highest-result?.timing?.avarage} mins.
            <br />
            behind the topper. Keep working hard
          </div>
        </div>
      </div>
    </div>
  )
}

export default SecondCard